import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import dynamic from 'next/dynamic'
import creatorStyles from '../styles/Creator.module.css'
import Image from "next/image"
import Badge from "react-bootstrap/Badge"
import RegisterModal from "../components/User/RegisterModal"
import { useState } from 'react'
import codePlayback from '../components/Gthr/Editor/Utils/CodePlaybackDemo'

const CodeMirror = dynamic(()=>import("../components/Gthr/Creator/CodeMirror"), {
    ssr: false
  })


export default function Creator() {

    const [registerModal, setRegisterModal] = useState(false)

    return (
        <Container> 

            <RegisterModal 
                    show={registerModal} 
                    setShow={setRegisterModal}
                    next={`creator`}
                    
                />
            <div className={creatorStyles.row}>

                    <div className={creatorStyles.left}>
                        <h1 className={creatorStyles.headline}>
                            Host <span className={creatorStyles.gradient_text}>1:1</span> live coding sessions 
                        </h1>
                        <p className={creatorStyles.subtext}>
                            <em>Ordinary Coders is a web design, live video platform
                                that gives you the tools to engage your audience with an online collaborative code editor
                            </em> 
                        </p>
                        <p className={creatorStyles.subtext}>
                            <ul>
                                <li>No credit card needed</li>
                                <li>Start monetizing your channel/blog in 15 minutes</li>
                            </ul>
                            
                        </p>

                        <Button className={creatorStyles.btn_grad}  onClick={e => setRegisterModal(true) }>Create Account</Button>

                        <br/> <br/> <br/> <br/>

                        <p className='text-muted'>
                   
                        </p>
                    </div>
                    
                <div className={creatorStyles.right}>
                    <div style={{minHeight:'600px', position:'relative'}}>
                        <CodeMirror 
                            codeSnippet={''}
                            codePlayback={codePlayback}
                        />

                    </div>
                    <div className={creatorStyles.row}>
                        <div className={creatorStyles.guest_div} >  
                            <Image
                                    src={`https://d2gdtie5ivbdow.cloudfront.net/static/img/man1-waive.jpg`}
                                    height={150}
                                    width={150}
                                    objectFit="cover"
                                    className={creatorStyles.creator_image} 
                                />

                        </div>
                       
                        <p className={creatorStyles.caption}>live video chat + collaborative code editor</p>
                        <div className={creatorStyles.creator_div} >
                            <Image
                                    src={`https://d2gdtie5ivbdow.cloudfront.net/static/img/women1_waive.jpg`}
                                    height={150}
                                    width={150}
                                    objectFit="cover"
                                    className={creatorStyles.creator_image} 
                                    
                                    
                                />                

                        </div>
                    </div>
                    <div className="text-center mt-2">
                        <p className={creatorStyles.caption_mobile}>live video chat + collaborative code editor</p>
                    </div>
                </div>

            </div>
            

            <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> 
                 <div>

                     <Row className={creatorStyles.row_bottom}>
                         <Col sm={12} md={6}>
                         <Image
                                    src={`https://d2gdtie5ivbdow.cloudfront.net/static/img/Group+4.png`}
                                    height={460}
                                    width={550}
                           
                              
                         
                                />
                      
                        
                         </Col>
                         <Col className="d-flex align-items-center">
                             <div>
                             <h3 className={creatorStyles.subheadline}>Create a Booking Page</h3>
                                <p className={creatorStyles.subtext}>
                                        Add an introduction, set your classes, available hours, and your rate.
                                        Offer Code-Along&apos;s, Q&A&apos;s, interview practice, and technical plannning.
                                        Booking pages can also contain previous projects, articles published on OrdinaryCoders,
                                        and video testimonials 
                                </p>

                             </div>
                     
                         </Col>
                     </Row>
                     <Row className={creatorStyles.row_bottom}>
                         <Col sm={12} md={6} className="d-flex align-items-center order-2">
                             <div>
                                    <h3 className={creatorStyles.subheadline}>Collect Booking Information</h3>
                                    <p className={creatorStyles.subtext}>
                                        Share your booking page with your audience so they can book 1:1 meetings based 
                                        on your availability.  Accept credit cards and receive payouts via Stripe Express
                                    
                                    </p>
                             </div>
        
                         </Col>
                         <Col className="order-1">
                         <Image
                                    src={`https://d2gdtie5ivbdow.cloudfront.net/static/img/Group+6.png`}
                                    height={460}
                                    width={556}
                    
                                 
                                />
                         </Col>
                     </Row>
                     <Row className={creatorStyles.row_bottom} >
                         <Col sm={12} md={6}>
                         <Image
                                src={`https://d2gdtie5ivbdow.cloudfront.net/static/img/Group+11.png`}
                                height={400}
                                width={664}
                       
                         
                                />
                         </Col>
                         <Col className="d-flex align-items-center">
                         <div>
                            <h3 className={creatorStyles.subheadline}>Code Together!</h3> 
                                <p className={creatorStyles.subtext}>
                                    Provide personalized 1-on-1 support from your browser<br/><br/>
                                           
                                    <Badge pill bg="purple-100" style={{color:'#6301ED', padding:'6px 10px', margin:'4px 2px'}}>
                                    Coming Soon
                                    </Badge> React, Next.js, cohort groups, and live events
                                </p>
                         </div>
                
                         </Col>
                     </Row>
                <div/>
            </div>
            <br/> <br/>
            <div className="text-left d-flex justify-content-center">
                <div className={creatorStyles.card}>
                 
                    {/* <Badge pill bg="purple-100" className={creatorStyles.card_headline}>
                    !
                    </Badge>  */}
                    <div className={creatorStyles.card_headline}>Value Proposition</div>
                    {/* <hr></hr> */}
                    <div className={creatorStyles.card_body}>
                        <ul>
                            <li>Start monetizing your existing content (Youtube, newsletter, Github, Stack Overflow, blog articles)<br/> by sharing your booking link</li>
                            <li>Set your hours to match your schedule and set your rate to match demand/opportunity cost</li>
                            <li>Provide personalized 1-on-1 web design assistance</li>
                            <li>No credit card needed</li>
                        </ul>
                    </div>
     
                </div>
            </div> 
            <br/> <br/> <br/> <br/> <br/> 

            <div className="text-left d-flex justify-content-center">
                <div className={creatorStyles.card}>
                 
                    {/* <Badge pill bg="purple-100" className={creatorStyles.card_headline}>
                      $
                    </Badge>  */}
                    <div className={creatorStyles.card_headline}>Pricing</div>
                    {/* <hr></hr> */}
                    <p><span style={{fontSize:'20px', fontWeight:'bold', marginLeft:"10px"}}>5%</span> each transaction</p>
                    <div className={creatorStyles.card_body}>
                        <ul>
                            <li>Processing and handling fees included in fee</li>
                            <li>Booking page and calendar scheduling</li>
                            <li>Accept payments with Stripe Express</li>
                            <li>Online collaborative editor</li>
                        </ul>
                        <Button className={creatorStyles.btn_grad}  onClick={e => setRegisterModal(true) }>Get Started</Button>
                    </div>
                </div>
            </div> 

            <br/> <br/> <br/> <br/> <br/> <br/> 

        </Container>


    )
}